// extracted by mini-css-extract-plugin
module.exports = {"switch":"_32rdjsYjhuFNw4yOTPq8F8","lever":"RoX566X4cyfBEDjfNTIpL"};